import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Dropdown, Avatar,
} from 'antd';
import {
  UserOutlined, LoginOutlined, LogoutOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';

const Header = styled.header.attrs({
  className: 'w-full flex justify-end items-center',
})`
  z-index: 1000;
  position: sticky;
  top: 0;
  height: 56px;
  padding: 0 16px;
  background: #FFFFFF;
  border-bottom: 1px solid var(--sthenus-bg-secondary);
  font-family: 'Source Sans 3', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
`;

const Title = styled.h2.attrs({
  className: 'ml-4',
})`
`;

const HeaderRight = styled.nav`
  margin-left:auto;
  display:inline-flex;

  & > i, & > span {
    margin: 0 10px;
  }
`;

const DashboardHeader = ({ title }) => {
  const navigate = useNavigate();
  const { logout, isAuthenticated, user } = useAuth();
  const nickname = user?.name || user?.nickname || user?.email;
  const picture = user?.picture;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'account',
      icon: <UserOutlined />,
      label: 'Account Info',
      onClick: () => navigate('/account/info'),
    },
    {
      type: 'divider',
    },
    ...(!isAuthenticated
      ? [
          {
            key: 'login',
            icon: <LoginOutlined />,
            label: 'Login',
            onClick: () => navigate('/login'),
          },
        ]
      : [
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
            onClick: handleLogout,
          },
        ]),
  ];

  return (
    <Header className="cursor-pointer">
      <Title style={{ fontFamily: 'Source Sans 3', fontWeight: 600, fontSize: 16, color: 'var(--sthenus-text-primary)' }}>{title}</Title>
      <HeaderRight>
        <Dropdown className="ml-4 mr-4" menu={{ items: menuItems }}>
          <div>
            <Avatar
              src={picture}
              style={{ marginRight: 5 }}
              size="larges"
              icon={<UserOutlined />}
            />
            <span className="text-xs" style={{ fontFamily: 'Source Sans 3', fontWeight: 500, fontSize: 16, color: 'var(--sthenus-text-primary)' }}>{nickname}</span>
            <i className="fa-solid fa-chevron-down" style={{ color: 'var(--sthenus-text-secondary)', fontSize: 14, paddingRight: 3, paddingLeft: 9 }} />
          </div>
        </Dropdown>
      </HeaderRight>
    </Header>
  );
};

export default memo(DashboardHeader);
